import {
	Directive,
	EventEmitter,
	HostBinding,
	HostListener,
	Output,
} from '@angular/core';
import { SafeUrl, DomSanitizer } from '@angular/platform-browser';

export interface FileHandle {
	file: File;
	url: SafeUrl;
}

@Directive({ selector: '[appDnd]' })
export class DndDirective {
	@Output() files: EventEmitter<FileHandle[]> = new EventEmitter();

	@HostBinding('style.background') private background = '#eee';

	constructor(private sanitizer: DomSanitizer) {}

	@HostListener('dragover', ['$event']) public onDragOver(evt: DragEvent) {
		evt.preventDefault();
		evt.stopPropagation();
	}

	@HostListener('dragleave', ['$event']) public onDragLeave(evt: DragEvent) {
		evt.preventDefault();
		evt.stopPropagation();
	}

	@HostListener('drop', ['$event']) public onDrop(evt: DragEvent) {
		evt.preventDefault();
		evt.stopPropagation();

		let files: FileHandle[] = [];
		if (evt && evt.dataTransfer) {
			for (let i = 0; i < evt.dataTransfer.files.length; i++) {
				const file = evt.dataTransfer.files[i];
				const url = this.sanitizer.bypassSecurityTrustUrl(
					window.URL.createObjectURL(file)
				);
				files.push({ file, url });
			}
			if (files.length > 0) {
				this.files.emit(files);
			}
		}
	}
}
